import { actions, paths } from 'src/constants';

export default {
  sendChatMessage: (prompt, context = {}) => ({
    [actions.API_CALL]: {
      types: [
        actions.AI_CHAT_REQUEST,
        actions.AI_CHAT_SUCCESS,
        actions.AI_CHAT_FAILURE,
      ],
      promise: (client) =>
        client.post(paths.api.AI_CHAT, { prompt, ...context }),
      prompt,
    },
  }),

  fetchDailyCheck: (locale) => ({
    [actions.API_CALL]: {
      types: [
        actions.AI_DAILY_CHECK_REQUEST,
        actions.AI_DAILY_CHECK_SUCCESS,
        actions.AI_DAILY_CHECK_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.AI_STUDENT_DAILY_CHECK, {
          params: { locale },
        }),
    },
  }),

  markDailyMessageAsRead: () => ({
    type: actions.AI_DAILY_MESSAGE_MARK_READ,
  }),

  resetChat: () => ({
    type: actions.AI_CHAT_RESET,
  }),

  toggleVisibility: () => ({
    type: actions.AI_CHAT_TOGGLE_VISIBILITY,
  }),
};
